(function () {
  var STORAGE_KEY = 'maimon-cookie-choice';
  var banner = document.getElementById('maimon-cookie-banner');
  if (!banner) return;

  var existing = null;
  try { existing = window.localStorage.getItem(STORAGE_KEY); } catch (e) { /* storage blocked - ask every time */ }
  if (existing === 'accept' || existing === 'reject') return;

  banner.hidden = false;

  banner.querySelectorAll('[data-cookie-choice]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var choice = btn.getAttribute('data-cookie-choice');
      try { window.localStorage.setItem(STORAGE_KEY, choice); } catch (e) { /* ignore */ }
      banner.hidden = true;
    });
  });
})();
